import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { Button, Col, Input, Radio, Row, Checkbox, Typography } from 'antd'
import { orderBy } from 'lodash'
import { INSPECTION_SECTION_TYPES } from '../../constant'
import { SECTION_TYPE_MEASUREMENT_SECTION } from '@/constant/qsf'
import { isEmptyValue } from '@/utils/common'
import TemplateSubSection from '../TemplateSubSection/TemplateSubSection'
import { useHasMeasurementAql } from '@/hook/useMeasurementAql'
import './TemplateSection.style.less'

interface Props {
  item: any
  index: any
  onSubSectionNameChange: (index, subIndex, value) => void
  onDeleteSubSection: (index, subIndex) => void
  onAddSubSection: (index) => void
  onAddCheckpoint: (index, subIndex) => void
  onDeleteCheckpoint: (index, subIndex, checkpointIndex) => void
  onCheckpointNameChange: (index, subIndex, checkpointIndex, value) => void
  onSelectOptionType: (index, value) => void
  onChangeInstruction: (index, value) => void
  onSubSectionHasConclusion: (idex, subIndex, value) => void
  onSubSectionType: (idex, subIndex, value) => void
  onSubSectionInstructionChange: (idex, subIndex, value) => void

  onChangeCheckpointControlType: (
    index,
    subIndex,
    checkpointIndex,
    value
  ) => void
  onCheckPointMandatory: (index, subIndex, checkpointIndex, value) => void
  onAddDataSource: (index, subIndex, checkpointIndex, value) => void
  onRemoveDatasource: (
    index,
    subIndex,
    checkpointIndex,
    datasourceIndex
  ) => void
  onCheckPointHidden: (
    sectionIndex,
    subSectionIndex,
    checkpointIndex,
    value
  ) => void
  onCheckPointHasDefaultValue: (
    sectionIndex,
    subSectionIndex,
    checkpointIndex,
    value
  ) => void
  onCheckPointDefaultValueChange: (
    sectionIndex,
    subSectionIndex,
    checkpointIndex,
    value
  ) => void
  onGroupSectionChange: (index, value) => void
  onGroupSectionNameChange: (index, value) => void
  showSectionGroup?: boolean
}

function TemplateSection(props: Props) {
  const { showSectionGroup = false } = props
  const hasMeasurementAqlSetting = useHasMeasurementAql()

  return (
    <>
      <div className="section-option-container">
        <Row align="middle">
          <Col span={4}>
            <p className="label">Options</p>
          </Col>
          <Col span={19}>
            <Radio.Group
              onChange={(e) =>
                props.onSelectOptionType(props.index, e.target.value)
              }
              value={props?.item?.options?.type}
            >
              {INSPECTION_SECTION_TYPES.map((item) => {
                return (
                  <Radio key={item.label} value={item.value}>
                    {item.label}
                  </Radio>
                )
              })}
            </Radio.Group>
          </Col>
        </Row>
        {props?.item?.options?.type === SECTION_TYPE_MEASUREMENT_SECTION &&
          hasMeasurementAqlSetting && (
            <Row>
              <Col span={19} offset={4}>
                <div className="measurement-aql-tooltip">
                  <InfoCircleOutlined
                    style={{ color: '#EF9747', fontSize: 18 }}
                  />
                  <Typography.Text
                    type="secondary"
                    style={{ margin: 0, fontSize: 14, color: '#323232' }}
                  >
                    Generates one measurement table per item.{' '}
                    <span style={{ fontWeight: 600 }}>
                      Sample size defaults to 5, or is set by Measurement AQL
                    </span>
                    , configured at the order or inspection.
                  </Typography.Text>
                </div>
              </Col>
            </Row>
          )}
        <Row align="middle" style={{ marginTop: 16 }}>
          <Col span={4}>
            <p className="label">Instructions</p>
          </Col>
          <Col span={19}>
            <Input
              value={props.item.options.instruction}
              onChange={(e) =>
                props.onChangeInstruction(props.index, e.target.value)
              }
              placeholder="Text"
              size="large"
              style={{ maxWidth: '97.4%' }}
            />
          </Col>
        </Row>
        {showSectionGroup && (
          <Row align="middle" style={{ marginTop: 16 }}>
            <Col span={4}>
              <Checkbox
                onChange={(e) =>
                  props.onGroupSectionChange(props.index, e.target.checked)
                }
                checked={props.item?.options?.group?.status ?? false}
                className="label"
              >
                Section Group
              </Checkbox>
            </Col>
            <Col span={19}>
              {props.item?.options?.group?.status && (
                <Input
                  placeholder="Text"
                  size="large"
                  value={props.item?.options?.group?.value ?? ''}
                  status={
                    props.item?.options?.group?.status &&
                    isEmptyValue(props.item?.options?.group?.value)
                      ? 'error'
                      : ''
                  }
                  onChange={(e) =>
                    props.onGroupSectionNameChange(props.index, e.target.value)
                  }
                  style={{ maxWidth: '97.4%' }}
                />
              )}
            </Col>
          </Row>
        )}
      </div>
      <div className="sub-section-container">
        {orderBy(props.item?.sub_sections, ['index'], ['asc'])?.map(
          (subItem: any, subIndex) => {
            return (
              <TemplateSubSection
                key={subIndex}
                index={props.index}
                subIndex={subIndex}
                subItem={subItem}
                onSubSectionInstructionChange={
                  props.onSubSectionInstructionChange
                }
                onDeleteSubSection={props.onDeleteSubSection}
                onSubSectionNameChange={props.onSubSectionNameChange}
                onAddCheckpoint={props.onAddCheckpoint}
                onDeleteCheckpoint={props.onDeleteCheckpoint}
                onCheckpointNameChange={props.onCheckpointNameChange}
                onSubSectionHasConclusion={props.onSubSectionHasConclusion}
                onSubSectionType={props.onSubSectionType}
                onChangeCheckpointControlType={
                  props.onChangeCheckpointControlType
                }
                onCheckPointMandatory={props.onCheckPointMandatory}
                onAddDataSource={props.onAddDataSource}
                onRemoveDatasource={props.onRemoveDatasource}
                onCheckPointHidden={props.onCheckPointHidden}
                onCheckPointHasDefaultValue={props.onCheckPointHasDefaultValue}
                onCheckPointDefaultValueChange={
                  props.onCheckPointDefaultValueChange
                }
              />
            )
          }
        )}
        <Button
          onClick={() => props.onAddSubSection(props.index)}
          className="add-sub-section-button"
        >
          <PlusOutlined className="plus-icon" />
          Add a Sub-Section
        </Button>
      </div>
    </>
  )
}

export default TemplateSection
